import React from 'react';
import { forTemplate } from 'app/common/lib/util/i18n';
import {
  useUpdateCardCoverMutation,
  SelectCoverQuery,
} from '@trello/graphql/generated';
import { MiniCard } from './MiniCard';
import {
  smallestPreviewBiggerThan,
  biggestPreview,
} from 'app/common/lib/util/preview';
import styles from './SelectSize.less';

const format = forTemplate('card_cover_chooser');

type Cover = NonNullable<SelectCoverQuery['card']>['cover'];

interface SelectSizeProps {
  cardId: string;
  cover?: Cover;
}

export const SelectSize: React.FunctionComponent<SelectSizeProps> = ({
  cardId,
  cover,
}) => {
  const [updateCardCover] = useUpdateCardCoverMutation();
  const removeCover = async () => {
    await updateCardCover({
      variables: {
        cardId,
        cover: null,
      },
    });
  };
  const setSize = async (size: string) => {
    await updateCardCover({
      variables: {
        cardId,
        cover: {
          size,
        },
      },
    });
  };

  const preview =
    cover && cover.scaled
      ? smallestPreviewBiggerThan(cover.scaled, 86, 64) ||
        biggestPreview(cover.scaled)
      : null;

  return (
    <div className={styles.selectSize}>
      <h4 className={styles.heading}>{format('size')}</h4>
      <div className={styles.sizeTiles}>
        <MiniCard
          selected={false}
          onClick={() => removeCover()}
          coverSize="none"
        />
        <MiniCard
          onClick={() => setSize('normal')}
          coverSize="normal"
          coverColor={cover?.color}
          coverImageUrl={preview?.url}
          selected={cover?.size === 'normal'}
        />
        <MiniCard
          onClick={() => setSize('full')}
          coverSize="full"
          coverColor={cover?.color}
          coverImageUrl={preview?.url}
          selected={cover?.size === 'full'}
          textColor={cover?.brightness === 'dark' ? 'light' : 'dark'}
        />
      </div>
    </div>
  );
};
